import styles from './index.module.scss';
import A from './A';
import { useLang } from '@/i18n';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import EfScrollAni from '@/efscrollani';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { TweenMax, TimelineMax } from 'gsap';
import { useEffect, useState } from 'react';
import ForBackup from './ForBackup';
import OnePicture from './OnePicture';
import SmartProduct from './SmartProduct';
import Flexible from './Flexible';
import F from './F';
import G1 from './G1';
import Choose from './Choose';
import EnergyStorage from './EnergyStorage';
import SmartGeneration from './SmartGeneration';
import PowerDistribution from './PowerDistribution';
import Explore from './Explore';
import EndorsedBy from './EndorsedBy';
import Disclaimer from './Disclaimer';
import JoinCommunity from './JoinCommunity';
import EcoflowUsers from './EcoflowUsers';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import AMZMemberDay from 'elem/compCommon/PillarPageActivities/AMZMemberDay';

const CALandingPage: React.FC = () => {
    if (typeof window !== 'undefined') {
        if (!window.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
        window.aniController = new ScrollMagic.Controller();
    }
    const { t } = useLang('wholehome');

    useEffect(() => {
        return () => {
            setTimeout(() => {
                /* @ts-ignore */
                if (aniController) aniController.destroy();
            });
        };
    }, []);

    const [isClient, setIsClient] = useState(false);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);

    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    return (
        <div className={styles.CALandingPage}>
            <A />
            <AMZMemberDay />
            <ForBackup />
            <OnePicture />
            <SmartProduct />
            <Flexible />
            <F />
            <G1 />
            <Choose />
            <EcoflowUsers />
            <JoinCommunity />
            <EnergyStorage />
            <SmartGeneration />
            <PowerDistribution />
            <Explore />
            <EndorsedBy />
            <Disclaimer />
            {isClient && <QuoteWinFloat callback={quoteCallback} />}
            {isClient && openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </div>
    );
};

export default CALandingPage;
